export default "__VITE_ASSET__BEL6aMEN__"